import MobileFirstPageTemplate from '@/components/templates/MobileFirstPageTemplate';

import TryScreenerOrganizationScore from '@/modules/try-screener/TryScreenerOrganizationScore';
import TryScreenerOrganizationValidation from '@/modules/try-screener/TryScreenerOrganizationValidation';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

const TryScreenerOrganizationPage = () => {
  // Use TanStack router to get params
  const { organizationSlug } = Route.useParams();

  const [isValidOrganization, setIsValidOrganization] = useState<boolean>(false);

  return (
    <MobileFirstPageTemplate>
      {!isValidOrganization && (
        <TryScreenerOrganizationValidation
          isValid={isValidOrganization}
          setIsValid={setIsValidOrganization}
          organizationSlug={organizationSlug}
        />
      )}
      {isValidOrganization && (
        <TryScreenerOrganizationScore organizationSlug={organizationSlug} isOrganizationValid={isValidOrganization} />
      )}
    </MobileFirstPageTemplate>
  );
};

export const Route = createFileRoute('/try-screener/$organizationSlug/')({
  staticData: { title: 'Screener' },
  component: TryScreenerOrganizationPage,
});
